module.exports = __webpack_public_path__ + "img/add_google_wallet.f8e3bdf6.png";